import Theme from "@microdoing/shared/constants/Theme";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import React from "react";
import { StyleSheet } from "react-native";
import ArrowLeft from "../Icons/Arrow/ArrowLeft";
import ArrowLeftSlider from "../Icons/ArrowSlider/ArrowLeftSlider";
import { MainTitle } from "./MainTitle";
import { PressableOpacity } from "./PressableOpacity";

const styles = StyleSheet.create({
  main: {},
  BackButton: {
    zIndex: 99999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
});

const BackButton = ({
  onPress,
  style = {},
  size = normalize(30),
  testID = "back-button",
  isArrowSlider = false,
  title = "",
}) => {
  return (
    <PressableOpacity
      testID={testID}
      onPress={onPress}
      style={[styles.BackButton, style]}
      hitSlop={Theme.HITSLOP}
    >
      {isArrowSlider ? (
        <ArrowLeftSlider
          height={normalize(size + 10)}
          width={normalize(size + 10)}
          color={theme.colors["neutral.900"]}
        />
      ) : (
        <ArrowLeft
          height={normalize(size)}
          width={normalize(size)}
          color={theme.colors["neutral.900"]}
        />
      )}

      {!!title && (
        <MainTitle marginLeft="s" variant="l8-bold">
          {title}
        </MainTitle>
      )}
    </PressableOpacity>
  );
};

export { BackButton };
